import mdbid from "mdbid";

export default {
    generate: mdbid
}
